export default __webpack_public_path__ + "static/media/red.8ce78352.jpg";